var map = {
	"./edit.fe2sink.modal/edit.fe2sink.modal": 82693,
	"./edit.fe2sink.modal/edit.fe2sink.modal.html": 14707,
	"./edit.fe2sink.modal/edit.fe2sink.modal.scss": 4495,
	"./edit.fe2sink.modal/edit.fe2sink.modal.ts": 82693,
	"./edit.geobyteSink.modal/edit.geobyteSink.modal": 85561,
	"./edit.geobyteSink.modal/edit.geobyteSink.modal.html": 84380,
	"./edit.geobyteSink.modal/edit.geobyteSink.modal.ts": 85561
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 47008;